import { render, staticRenderFns } from "./EnterpriseDetails.vue?vue&type=template&id=677d53e7&scoped=true"
import script from "./EnterpriseDetails.vue?vue&type=script&lang=js"
export * from "./EnterpriseDetails.vue?vue&type=script&lang=js"
import style0 from "./EnterpriseDetails.vue?vue&type=style&index=0&id=677d53e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677d53e7",
  null
  
)

export default component.exports